import React, { useEffect,useState } from 'react';
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import { mainTable } from '../css/Common';
import AutoDropDown from '../ReusableComponents/AutoCompleteDropDown';
import TextArea from '../ReusableComponents/TextArea';
import { BindAPI } from '../services/APIConnection';
import usePrevious from "../Hook/UsePrevious";
const Consumptionpopup = ({
    data,
    data1,
    
   
}) => {
const [date,setDate]=useState([])
  const [tableData, setTableData] = useState([
    {
      itemtype: '',
      itemcategory: '',
      itemname: '',
      quantity: '',
      uom: '',
      itemList: [], // filtered item list per row
      itemCategoryList: [],
    },
  ]);
 const [itemdd, setitemdd] = useState([])
  const [itemcategorydd, setitemcategorydd] = useState([])
  const [itemtype, setitemtype] = useState([])
  useEffect(() => {
      BindConsumptionValues();
    }, []);
  
    const BindConsumptionValues = async () => {
  
      const response = await BindAPI("Consumption/BindConsumptionValues")
      console.log("Consumption Dropdown:", response);
      if (response && response.data) {
        const ItemTypes = response.data.Table.map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }));
        setitemtype(ItemTypes);
        setitemcategorydd(response.data.Table1); // show all initially
  
  
        setitemdd(response.data.Table2); // show all initially
  
  
  
      } else {
        setitemtype([]);
        setitemcategorydd([]);
        setitemdd([]);
      }
    };
  useEffect(() => {
                if (data1?.length > 0) {
                  setTableData(data1);
    
                }
              }, [data1]);
    
const handleAddRow=()=>{}
const handleDeleteRow=()=>{}
 const previousTableData = usePrevious(tableData);
 const updateTableData = async () => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData)
      console.log("itemcategory", itemcategorydd)
      
      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemtype) {
          const filteredCategories = itemcategorydd
            .filter((item) => item.MstItemTypeId === row.itemtype)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }
        
        // Update itemList and uom if itemcategory is selected
        if (row?.itemcategory) {
          const filteredItems = itemdd

            .filter((item) => item.MstItemCategoryId === row.itemcategory)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemname
          );
          row.uom = selectedItem?.uom || '';
        }
      }

      setTableData(updatedTableData);
    }
  };
    
  const appendDataToConsumeTable = (newDataString) => {

    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {

      return {
        itemtype: data.MstItemTypeId,
        itemcategory: data.MstItemCategoryId,
        itemname: data.MstItemId,
        uom: data.UOM,
        quantity: data.Quantity,


      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);






  };
 const updateTableData1 = async (formattedDataArray) => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(formattedDataArray)) {
      const updatedTableData = [...formattedDataArray];
      console.log(updateTableData)
      console.log("itemcategory", itemcategorydd)
      
      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemtype) {
          const filteredCategories = itemcategorydd
            .filter((item) => item.MstItemTypeId === row.itemtype)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }
        
        // Update itemList and uom if itemcategory is selected
        if (row?.itemcategory) {
          const filteredItems = itemdd

            .filter((item) => item.MstItemCategoryId === row.itemcategory)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemname
          );
          row.uom = selectedItem?.uom || '';
        }
      }

      setTableData(updatedTableData);
    }
  };


    const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      //setLaundryIssueDetails(jsonString);
      console.log("data", tableData)

      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };


   useEffect(() => {
           
         
  
          if (data.length != 0) {
              const currentDate = data?.ConsumeDate;
  
              const formattedDate = currentDate.split("T")[0];
              setDate(formattedDate)
          }
          if (data1.length != 0) {
  
              appendDataToConsumeTable(JSON.stringify(data1))
          } else {
              setTableData([
                  ...tableData,
                  {
                      itemtype: "",
                      itemcategory: "",
                      itemname: "",
                      uom: "",
                      quantity: "",
                     
                      itemcategoryList: [],
                      itemList: []
                  },
              ]);
          }
      }, [data]);
    return (

      <>


    
        <div className="w-full">
            <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
                {/* Item Type Dropdown */}
                <div className="mt-10"></div>

          <div className={mainTable.grid3}>

            { /*<div className="w-60 mt-12 mb-6">*/}
            <InputText
              title="Consumption No"
              inputType="text"

              name="consumptionno"
              content={data.ConsumptionNo}
              disabled={true}
            />
            {/* </div>*/}

            <InputText
              inputType="date"
              title="Date"
              name="consumedate"
             

             

              content={date}
              placeholder="Enter Date"
                 disabled={true}
              // tabIndex="9"
              isRequired={true}
              
              classStar="text-red-500"
            />

          </div>

          <div className="w-full  max-h-[400px] ">
            <table className="w-full border border-gray-300 mt-6">
              <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
                <tr>
                  <th className="border px-4 py-2">S.No</th>
                  <th className="border px-4 py-2">ItemsType</th>
                  <th className="border px-4 py-2">Item Category</th>
                  <th className="border px-4 py-2">ItemName</th>
                   <th className="border px-4 py-2">U.O.M</th>
                  <th className="border px-4 py-2">Quantity</th>
                 

                  {/* <th className="border px-4 py-2">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td className="border px-1 py-2 w-[10px] text-center">{index + 1}</td>
                    {/* Item Type */}
                    <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                      <div className="w-40"></div>
                      <AutoDropDown
                        name="itemtype"
                        options={itemtype||[]}
                        selectedOption={
                          row.itemtype
                            ? itemtype.find((x) => x.value === row.itemtype)
                            : ""
                        }
                        placeholder="Select"
                        Class="custom-class"
                        disabled={true}
                       
                      />
                    </td>

                    {/* Item Category */}
                    <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                      <div className="w-40"></div>
                      <AutoDropDown
                        name="itemcategory"
                       options={ row.itemCategoryList||[]}
                                
                        placeholder="Select"
                        Class="custom-class"
                        selectedOption={
                                                    row.itemcategory
                                                        ? row.itemCategoryList.find(
                                                            (x) => x.value == row.itemcategory
                                                        )
                                                        : ""
                                                }
                                                disabled={true}                     
                      />
                    </td>

                    {/* Item Name */}
                    <td className="border px-2 py-2 w-[160px] relative overflow-visible">
                      <div className="w-40"></div>
                      <AutoDropDown
                        name="itemname"
                        options={ row.itemList||[]}
                        selectedOption={
                          row.itemname
                            ? row.itemList.find(
                              (x) => x.value == row.itemname
                            )
                            : ""
                        }// safe access
                        placeholder="Select"
                        Class="custom-class"
                        disabled={true}
                      />
                    </td>

                          {/* U.O.M */}
                    <td className="border px-2 py-2 w-[140px]">
                      <InputText
                        inputType="text"
                        name="uom"
                        content={row.uom}
                        disabled={true}
                      />
                    </td>

                    {/* Quantity */}
                    <td className="border px-2 py-2 w-[120px]">
                      <InputText
                        inputType="number"
                        name="quantity"
                        content={row.quantity}
                        disabled={true}
                      />
                    </td>

                  



{/*                 
                    <td className="border px-4 py-2 w-[100px]">
                      <div className="flex gap-4 items-center justify-center">
                   
                        <svg
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          className="w-6 h-6 text-black cursor-pointer"
                          onClick={() => handleDeleteRow(index)}
                        >
                          <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                        </svg>

            
                        {index === tableData.length - 1 && tableData.length < 4 && (
                          <svg
                            viewBox="0 0 1024 1024"
                            fill="currentColor"
                            onClick={handleAddRow}
                            className="w-6 h-6 text-black cursor-pointer"
                          >
                            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                          </svg>
                        )}
                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">

            <TextArea
              inputType="text"
              title="Reason"
              name="reason"
              rows="4"
              disabled={true}
              maxlength={500}
              content={data.Description}
              placeholder="Enter Reason"
              
            />
          </div>
            </form>
        </div>

       
        </>
    );
};

export default Consumptionpopup;


